import { render } from "./WraperHeaderMuseum.vue?vue&type=template&id=10475d51&scoped=true"
import script from "./WraperHeaderMuseum.vue?vue&type=script&lang=js"
export * from "./WraperHeaderMuseum.vue?vue&type=script&lang=js"

import "./WraperHeaderMuseum.vue?vue&type=style&index=0&id=10475d51&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10475d51"]])

export default __exports__